export default "__VITE_PUBLIC_ASSET__3cacdf6a__"